import {WixSdk} from '@wix/js-sdk-wrapper';

export const getCompId = () => {
  return WixSdk.Utils.getCompId();
};

export function getOriginalComponentId() {
  return WixSdk.Utils.getOrigCompId();
}
